<template>
  <div>
    <h1>Hoppsan!</h1>

    <div class="error">
      <p v-if="error === 'slot-taken'">
        Tiden du har valt har redan hunnit bli bokad. <br>
        Prova att välja en annan tid.
      </p>

      <p v-if="error === 'max-pizzas'">
        Du kan beställa max {{ settings.timeslotLimit }} pizzor åt gången.
      </p>

      <p v-if="error === 'not-open'" class="error">
        Beställningen är tyvärr inte öppen.
      </p>

      <p v-if="error === 'unknown'" class="error">
        Ett okänt fel inträffade. Prova att lägga din beställning igen.
      </p>
    </div>

    <p>
      Om du har frågor, vänligen ring oss på:<br>
      <a href="tel:+46840919811">08-409 19 811</a>
    </p>
  </div>
</template>

<script>
  import { get } from 'lodash';
  import { mapState } from 'vuex';

  export default {
    name: 'OrderModal',
    computed: {
      ...mapState(['modal']),
      ...mapState('order', ['settings']),

      status () {
        return get(this.modal, 'data.status', null);
      },
      error () {
        const error = get(this.modal, 'data.error', null);

        if (error) {
          return error;
        }

        if (status && status !== 200) {
          return { error: 'unknown' };
        }

        return null;
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  h1
    @extend .t-orderHeader

  .error
    margin-bottom: 1rem

  a
    color: $red

</style>
